import i18n from "../../../../../constants/i18n";
import { TCorePage } from "../../../../../Types";
import ET3Div from "../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import Et3Text from "../../../../../core/et3-text";

const AuditorAuditReportPage = withLiteObserverAndTheme<{
  pageName: TCorePage;
  takenActionType: string;
}>((props) => {
  const { pageName, takenActionType, theme } = props;
  const { colors } = theme;
  const actionTaken =
    pageName === "AUDITOR_AUDIT"
      ? takenActionType === "WARN" || takenActionType === "REPORT_WARNING"
        ? i18n.get("USER_WARNED")
        : takenActionType === "REPORT_RESOLVE"
          ? i18n.get("REPORT_RESOLVE")
          : takenActionType === "REPORT_EMAIL"
            ? i18n.get("REPORT_EMAIL")
            : takenActionType === "REPORT_BAN" || takenActionType === "BANNED"
              ? i18n.get("USER_BANNED")
              : takenActionType === "TEMPORARY_BANNED"
                ? i18n.get("USER_TEMPORARY_BANNED")
                : ""
      : "";
  const actionTakenColor =
    pageName === "AUDITOR_AUDIT"
      ? takenActionType === "WARN" || takenActionType === "REPORT_WARNING"
        ? colors.all.orange
        : takenActionType === "REPORT_RESOLVE"
          ? colors.all.green
          : takenActionType === "REPORT_EMAIL"
            ? colors.all.green
            : takenActionType === "REPORT_BAN" || takenActionType === "BANNED"
              ? colors.all.red
              : takenActionType === "TEMPORARY_BANNED"
                ? colors.all.red
                : "transparent"
      : "transparent";

  return pageName === "AUDITOR_AUDIT" ? (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      fDirection="row"
      justifyContent="space-around"
      alignItems="center"
      withShadow={false}
      width={400}
      height={40}
      color={actionTakenColor}
      style={{}}
      onClick={() => {}}
    >
      <Et3Text
        fontFamily={"BOLD"}
        fontSize={18}
        text={i18n.get("ACTION_TAKEN")}
        isSpan={false}
        color={colors.all.bondiBlue}
        style={{}}
      />
      {actionTaken}
    </ET3Div>
  ) : null;
});
export default AuditorAuditReportPage;
